"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCss = void 0;
const emotion_1 = require("emotion");
const react_1 = require("react");
function useCss(maker, props = [], externalClasses) {
    return (0, react_1.useMemo)(() => {
        const cssifiedClasses = {};
        // eslint-disable-next-line prefer-spread
        const internalClasses = maker.apply(null, props);
        Object.keys(internalClasses).forEach(v => {
            if (externalClasses === null || externalClasses === void 0 ? void 0 : externalClasses[v]) {
                cssifiedClasses[v] = (0, emotion_1.cx)((0, emotion_1.css)(internalClasses[v]), externalClasses[v]);
            }
            else {
                cssifiedClasses[v] = (0, emotion_1.css)(internalClasses[v]);
            }
        });
        return cssifiedClasses;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...props, maker, externalClasses]);
}
exports.useCss = useCss;
exports.default = useCss;
